// Development environment configuration
const devConfig = {
  domain: 'dev-8wo2lr85hpu1lbx6.us.auth0.com',
  clientId: 'LvbTbYIN2NkvYkBVle9x1vaRCHPsmQha',
  audience: 'https://i6u5xcro82.execute-api.us-east-1.amazonaws.com/test/',
  apiBaseUrl: 'https://fxycsff094.execute-api.us-east-1.amazonaws.com/test/auth/api',
};

// Production environment configuration
const prodConfig = {
  domain: 'grasply-ai.us.auth0.com',
  clientId: 'zl2QcY66WQ5MKTrY4q9HgW1J3Pl4xn7j',
  audience: 'https://jxqmj6uul2.execute-api.us-east-1.amazonaws.com/prod/',
  apiBaseUrl: 'https://rl7hgys7g2.execute-api.us-east-1.amazonaws.com/prod/auth/api',
};

const env = devConfig;

const config = {
  auth0Domain: env.domain,
  auth0ClientId: env.clientId,
  auth0Audience: env.audience,
  auth0Callback: env.apiBaseUrl,
  apiBaseUrl: env.apiBaseUrl,
  authServiceBaseUrl: env.apiBaseUrl,
};

export default config; 


